import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseService } from './base.service';
 
export interface BVNdetails {
  policyNumber: string;
  clientCode: string;
  names: string;
  dateOfBirth: string;
  physicalAddress: string;
  bvn: string;
  email: string;
  telephone: string;
}
 
export interface ApiResponse {
  result: BVNdetails[];
  isSuccessful?: boolean;
  errorMessages?: string;
}
 
@Injectable({
  providedIn: 'root'
})
export class BVNService {
 
  constructor(private baseService: BaseService, private http: HttpClient) {
    this.baseService.http = http;
  }
 
  GetPolicyNumber(code: string): Observable<BVNdetails | null> {
    const url = `${this.baseService.baseUrl}/VerificationService/GetPolicyHolderDetails?policyNumber=${code}`;
    return this.baseService.http.get<ApiResponse>(url, { headers: this.baseService.headers }).pipe(
      map(response => {
        if (response && response.result && response.result.length > 0) {
          return response.result[0];
        }
        return null;
      }),
      catchError(error => {
        console.error('API Call Error:', error);
        return of(null);
      })
    );
  }
 
  GetPolicyHolderDetails(code: string): Observable<ApiResponse> {
    const url = `${this.baseService.baseUrl}/VerificationService/GetPolicyHolderDetails?policyNumber=${code}`;
    return this.baseService.http.get<ApiResponse>(url, { headers: this.baseService.headers }).pipe(
      map((response) => {
        
        return response;
      }),
      catchError((error) => {
        console.error('❌ API Call Error:', error);
        return of({ result: [], isSuccessful: false });
      })
    );
  }
 
  UpdateClientDetails(policyNumber: string, email: string, phoneNumber: string, address: string, bvn: string): Observable<ApiResponse> {
    const url = `${this.baseService.baseUrl}/VerificationService/UpdateClientDetails?policyNumber=${policyNumber}&email=${email}&phoneNumber=${phoneNumber}&address=${address}&bvn=${bvn}`;
 
    return this.baseService.http.put<ApiResponse>(url, {}, { headers: this.baseService.headers }).pipe(
      map(function(response) {
       
        return response;
      }),
      catchError(function(error) {
        console.error('❌ Update API Call Error:', error);
        return of({
          result: null,
          isSuccessful: false,
          errorMessages: error.error && error.error.message ? error.error.message : 'Failed to update client details.'
        });
      })
    );
  }
 
 
}